import React, { useEffect, useMemo, useState } from "react";
import "./Checkout.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  MotifIcon,
  MotifTabNavigation,
  MotifTabControl,
  MotifTruncate,
  MotifErrorMessage,
  MotifTooltip,
  MotifToast,
  MotifAccordion,
  MotifAccordionTrigger,
  MotifAccordionContent,
} from "@ey-xd/motif-react";
import {
  IconoirArrowLeft,
  IconoirEditPencil,
  IconoirCodepen,
  IconoirWarningCircle,
  IconoirPolarSh,
  IconoirArrowRight,
} from "@ey-xd/motif-icon";
import Loader from "../../components/Loader";
import Breadcrumb from "../../components/Breadcrumb";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  callOrderNow,
  callSaveEstimate,
  fetchCheckoutData,
  OrderSkuDetails,
  resetCheckoutSate,
  resetEstimateChangeState,
  resetRelaodPageState,
  ResponseDetails,
  updateEstimateChangeState,
  updateOrderBundle,
  updateOrderBundleList,
} from "../../store/slices/CheckoutSlice";
import { CHECKOUT, ORDER_BUNDLE_DESCRIPTION } from "./Constants";
import { OrderCard } from "./Components/OrderCard/OrderCard";
import { Accordian } from "./Components/Accordian/Accordian";
import InputBox from "../../components/Form/InputBox/InputBox";
import Button from "../../components/Button/Button";
import { OrderPlaced } from "./Components/OrderPlaced/OrderPlaced";
import { OrderResponseDetails } from "./Components/OrderExpected/OrderExpected";
import { OrderExpected } from "./Components/OrderExpected/OrderExpected";
import {
  compareCheckoutData,
  getEngagementErrorFromResponse,
  getNextOpportunityCode,
  getOrderSkuDetails,
  getRetiredSkuList,
  getSkuListFromOrderBundle,
  getSkuListFromOrderBundleWithEngagement,
  getSkuListFromOrderBundleWithEngagementEstimate,
  getTotalOrderAmountVariable,
  getUniqueEngagementCode,
  renderEngagementName,
  resetEngagementCode,
  updateOpportunityCode,
} from "./CheckoutHelper";
import UpdateOrderWarningPopUp from "./Components/UpdateOrderWarningPopUp/UpdateOrderWarningPopUp";
import checkoutEmptyImg from "../../assets/images/checkout-empty-state.svg";
import noOrderAccessImg from "../../assets/images/noOrderAccess.svg";
import {
  EngagementError,
  OpportunityMismatchError,
  OrderUpdateObj,
} from "./type";
import {
  getOpportunityCodeFromLocal,
  getOrderIdFromLocal,
  removeOrderIdFromLocal,
  removeEmojis,
  setOpportunityCodeInLocal,
  TextAbstract,
  removeOpportunityCodeFromLocal,
} from "../../utils/common";

import EngagementErrorTooltip from "./Components/EngagementErrorTooltip/EngagementErrorTooltip";
import { isEmpty, isStringHavingSpecialChars } from "../../utils/Validator";
import {
  fetchEngagementName,
  fetchEngagementNameException,
  resetEngagementNameExceptionState,
  resetEngagementNameState,
} from "../../store/slices/EngagementNameSlice";
import {
  fetchOpportunityName,
  resetOpportunityNameState,
} from "../../store/slices/OpportunityNameSlice";
import {
  DELETE_ESTIMATE,
  DELETED_ESTIMATE_SUGGESTION,
  DELETED_ESTIMATE_SUGGESTION2,
  DELETED_ESTIMATE_SUGGESTION3,
  NO_ACCESS_ESTIMATE,
  NO_ACCESS_ESTIMATE_SUGGESTION,
  NO_ACCESS_ESTIMATE_SUGGESTION2,
  RETIRED_SKU_IN_CHECKOUT_MESSAGE,
  VIEW_CHECKOUT_WARNING,
} from "../../Constant";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import InfoTooltip from "../../components/InfoTooltip";
import { variableTotalInfo } from "../../utils/skuTable";
import { getSyncFormattedDate } from "../../components/MyWorkspace/helper";
import { useAppDispatch } from "../../store/hooks";
import EngagementConfirmationModal from "../../components/EngagementConfirmationModal";
const Checkout: React.FC = () => {
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState(0);

  const [fetchCheckoutResponse, setFetchCheckoutResponse] =
    useState<ResponseDetails | null>(null);

  const emailId: string = useSelector(
    (state: RootState) => state.UserProfileSlice.emailId,
  );

  const checkoutListLoading = useSelector(
    (state: RootState) => state.CheckoutSlice.isLoading,
  );
  const checkoutListData = useSelector(
    (state: RootState) => state.CheckoutSlice.data,
  );

  const checkoutListDataError = useSelector(
    (state: RootState) => state.CheckoutSlice.error,
  );

  const errorcheckoutList = useSelector(
    (state: RootState) => state.CheckoutSlice.error,
  );

  const engagementNameInStore = useSelector(
    (state: RootState) => state.EngagementNameSlice.data,
  );
  const engagementNameLoading = useSelector(
    (state: RootState) => state.EngagementNameSlice.isLoading,
  );

  const engagementNameError = useSelector(
    (state: RootState) => state.EngagementNameSlice.error,
  );

  const opportunityNameInStore = useSelector(
    (state: RootState) => state.OpportunityNameSlice.data,
  );
  const opportunityNameLoading = useSelector(
    (state: RootState) => state.OpportunityNameSlice.isLoading,
  );

  const opportunityNameError = useSelector(
    (state: RootState) => state.OpportunityNameSlice.error,
  );
  const engagementNameExceptionInStore = useSelector(
    (state: RootState) => state.EngagementNameSlice.dataException,
  );
  const engagementNameExceptionLoading = useSelector(
    (state: RootState) => state.EngagementNameSlice.isLoadingException,
  );

  const engagementNameExceptionError = useSelector(
    (state: RootState) => state.EngagementNameSlice.errorException,
  );
  const [opportunityCode, setOpportunityCode] = useState<string>(
    checkoutListData?.OpportunityId || "",
  );

  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );

  const isReloadPage = useSelector(
    (state: RootState) => state.CheckoutSlice.reloadPage,
  );

  const uniqueEngagement = getUniqueEngagementCode(checkoutListData);
  const defaultEng =
    uniqueEngagement && uniqueEngagement.length > 0 ? uniqueEngagement[0] : "";

  const [engagementCode, setEngagementCode] = useState<string>(defaultEng);
  const [engagementName, setEngagementName] = useState<string>("");
  const [opportunityName, setOpportunityName] = useState<string>("");
  const [opportunityError, setOpportunityError] = useState<string>("");
  const defaultEngException =
    uniqueEngagement && uniqueEngagement.length > 1 ? uniqueEngagement[1] : "";
  const [engagementCodeException, setEngagementCodeException] =
    useState<string>(defaultEngException);
  const [engagementNameException, setEngagementNameException] =
    useState<string>("");
  const [isOrder, setIsOrder] = useState<boolean>(false);
  const [isSaveEstimate, setIsSaveEstimate] = useState<boolean>(false);
  const [isOrderUpdateWarning, setIsOrderUpdateWarning] =
    useState<boolean>(false);
  const [orderData, setOrderData] = useState<OrderResponseDetails | null>(null);
  const [orderName, setOrderName] = useState<string>("");
  const [saveEstimateData, setSaveEstimateData] =
    useState<OrderResponseDetails | null>(null);
  const [checkOutListState, setCheckOutListState] =
    useState<ResponseDetails | null>(null);
  const [isOrderEdit, setIsOrderEdit] = useState<boolean>(false);
  const [reloadPage, setReloadPage] = useState<boolean>(false);
  const [isChangedActive, setIsChangedActive] = useState<boolean>(false);
  const [disableBtns, setDisableBtns] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { orderID } = useParams();
  const [unexpectedError, setUnexpectedError] = useState<boolean>(false);
  const opportunityCodeFromUrl = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return (queryParams.get("ocode") || "").trim().toUpperCase();
  }, [location.search]);

  const [opportunityCodeMistachWithIcode, setOpportunityCodeMistachWithIcode] =
    useState<boolean>(false);
  const [isAddProductFlow, setIsAddProductFlow] = useState<boolean>(false);

  const viewMode = !!(
    emailId &&
    checkoutListData?.CreatedByEmail?.toLocaleLowerCase() !==
      emailId.toLocaleLowerCase()
  );
  const isShared = !isNaN(Number(orderID));
  const currentOrderId = !isNaN(Number(orderID))
    ? Number(orderID)
    : Number(getOrderIdFromLocal());
  const [isNoOrder, setIsNoOrder] = useState<boolean>(false);
  const [isOrderDeleted, setIsOrderDeleted] = useState<boolean>(false);
  const [noOrderAccess, setNoOrderAccess] = useState<boolean>(false);
  const [engagementError, setEngagementError] = useState({
    isErrorEngagement: false,
    isErrorOpportunity: false,
    messageEngagement: "",
    messageOpprotunity: "",
    isErrorSkuList: false,
    errorSkuList: [],
    iCodeError: true,
  });

  const [showEngagementException, setShowEngagementException] = useState(false);
  const [shouldShowEnagagementException, setShouldShowEnagagementException] =
    useState(false);
  const [engagementExceptionError, setEngagementExceptionError] = useState({
    isErrorEngagement: false,
    isErrorOpportunity: false,
    messageEngagement: "",
    messageOpprotunity: "",
    isErrorSkuList: false,
    errorSkuList: [],
    iCodeError: true,
  });
  const [opportunityMismatchError, setOpportunityMismatchError] =
    useState<OpportunityMismatchError>({
      isErrorOpportunity: false,
      messageOpprotunity: "",
      engagement: {
        code: "",
        name: "",
      },
      opportunity: {
        code: "",
        name: "",
      },
      nextOpportunity: {
        code: "",
        name: "",
      },
    });
  const [isLoadingAddProduct, setIsLoadingAddProduct] = useState(false);
  const [isLoadingEstimate, setIsLoadingEstimate] = useState(false);
  const [isLoadingOrderNow, setIsLoadingOrderNow] = useState(false);
  const [preventAutoFill, setPreventAutoFill] = useState(false);
  const [showVariableCost, setShowVariableCost] = useState(false);
  const viewportWidth =
    typeof window !== "undefined" ? window.innerWidth : 1920;
  const orderNameTruncateMaxWidth = useMemo(
    () => Math.min(Math.round(viewportWidth * 0.65), 1245),
    [viewportWidth],
  );

  const [isEngagementCodeChanged, setIsEngagementCodeChanged] = useState(false);

  const [isLoadingConfirmation, setIsLoadingConfirmation] = useState(false);

  const isDraftChanged = useMemo(() => {
    return (
      isChangedActive && checkoutListData?.OrderStatus !== "order_estimate"
    );
  }, [isChangedActive, checkoutListData?.OrderStatus]);

  const resetOpportunityMismatchError = () => {
    setOpportunityMismatchError({
      ...opportunityMismatchError,
      isErrorOpportunity: false,
      messageOpprotunity: "",
      engagement: {
        code: "",
        name: "",
      },
      opportunity: {
        code: "",
        name: "",
      },
      nextOpportunity: {
        code: "",
        name: "",
      },
    });
  };

  useEffect(() => {
    if (checkoutListData?.OrderStatus === "order_estimate" && isChangedActive) {
      if (!compareCheckoutData(fetchCheckoutResponse, checkOutListState)) {
        dispatch(updateEstimateChangeState());
      } else {
        dispatch(resetEstimateChangeState());
      }
    }
  }, [checkOutListState, dispatch]);

  useEffect(() => {
    if (configData === null || configData === undefined) {
      dispatch(fetchSkuConfigData());
    }
  }, [configData]);

  useEffect(() => {
    if (opportunityCodeFromUrl) {
      setOpportunityCodeInLocal(opportunityCodeFromUrl);
    }
  }, [opportunityCodeFromUrl]);

  useEffect(() => {
    dispatch(resetCheckoutSate());
    const getCheckoutResponse = async () => {
      const fetchCheckoutResponse = await dispatch(
        fetchCheckoutData({
          Action: "checkout",
          OrderId: currentOrderId,
          shareEstimate: isShared,
        }),
      );
      if (fetchCheckoutResponse?.payload?.Code === 200) {
        setFetchCheckoutResponse(fetchCheckoutResponse?.payload?.Data || null);
      }
    };

    if (currentOrderId > 0) {
      getCheckoutResponse();
      setIsNoOrder(false);
      if (isReloadPage) {
        setIsChangedActive(false);
      }
    } else {
      dispatch(resetCheckoutSate());
      dispatch(resetRelaodPageState());
      setIsChangedActive(false);
      setIsNoOrder(true);
      if (isEmpty(engagementCodeException)) setShowEngagementException(false);
    }
  }, [dispatch, currentOrderId, reloadPage]);

  useEffect(() => {
    return () => {
      dispatch(resetCheckoutSate());
      dispatch(resetEngagementNameState());
      dispatch(resetEngagementNameExceptionState());
      dispatch(resetOpportunityNameState());
    };
  }, [dispatch]);

  useEffect(() => {
    const inputString = engagementCode.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);
    if (inputString.length === 10 && (firstChar === "E" || firstChar === "I")) {
      setEngagementName(inputString);
    } else {
      setEngagementName("");
    }
  }, [engagementCode]);

  useEffect(() => {
    const inputString = engagementCodeException.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);
    if (inputString.length === 10 && firstChar === "E") {
      setEngagementNameException(inputString);
    } else {
      setEngagementNameException("");
    }
  }, [engagementCodeException]);

  useEffect(() => {
    const shouldShow =
      !engagementNameLoading &&
      !engagementNameError &&
      shouldShowEnagagementException;

    setShowEngagementException(shouldShow);
  }, [
    engagementNameError,
    shouldShowEnagagementException,
    engagementNameLoading,
  ]);

  useEffect(() => {
    const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
      // Recommended
      event.preventDefault();
      // Included for legacy support, e.g. Chrome/Edge < 119
      event.returnValue = isDraftChanged ? true : false;
    };
    if (isDraftChanged) {
      window.addEventListener("beforeunload", beforeUnloadHandler, {
        capture: true,
      });
      const targetDiv = document.querySelectorAll(
        ".sidenav-wrapper .motif-vertical-navigation-menu",
      );
      targetDiv.forEach((navElem) => {
        if (navElem instanceof HTMLElement) {
          navElem.classList.add("no-active-link");
        }
      });
    } else {
      window.removeEventListener("beforeunload", beforeUnloadHandler, {
        capture: true,
      });
      const targetDiv = document.querySelectorAll(
        ".sidenav-wrapper .motif-vertical-navigation-menu",
      );
      targetDiv.forEach((navElem) => {
        if (navElem instanceof HTMLElement) {
          navElem.classList.remove("no-active-link");
        }
      });
    }
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler, {
        capture: true,
      });
    };
  }, [isDraftChanged]);

  const handleOrderUpdated = () => {};

  useEffect(() => {
    setPreventAutoFill(false);
  }, [currentOrderId]);

  useEffect(() => {
    if (checkoutListDataError === "access_estimate") {
      setNoOrderAccess(true);
      setIsOrderDeleted(false);
      return;
    } else if (checkoutListDataError === "delete_estimate") {
      setIsOrderDeleted(true);
      setNoOrderAccess(false);
      return;
    } else {
      setIsOrderDeleted(false);
      setNoOrderAccess(false);
    }
    setEngagementCode(defaultEng);
    setEngagementCodeException(defaultEngException);
    setCheckOutListState(checkoutListData);
    setOrderName(checkoutListData?.Description || "");
    if (reloadPage) {
      setReloadPage(false);
    }
    setUnexpectedError(false);
    if (!preventAutoFill) {
      const opportunityCodeFromLocal = getOpportunityCodeFromLocal();
      const opportunityCodeFromApi = (checkoutListData?.OpportunityId || "")
        .trim()
        .toUpperCase();
      const shouldUseOpportunityCodeFromLocal =
        checkoutListData?.OrderStatus === "order_draft" &&
        !!opportunityCodeFromLocal;
      setOpportunityCode(
        shouldUseOpportunityCodeFromLocal
          ? opportunityCodeFromLocal
          : opportunityCodeFromApi,
      );
    }

    setEngagementError({
      ...engagementError,
      isErrorEngagement: false,
      isErrorOpportunity: false,
      messageEngagement: "",
      messageOpprotunity: "",
      isErrorSkuList: false,
      errorSkuList: [],
      iCodeError: false,
    });
    setEngagementExceptionError({
      ...engagementExceptionError,
      isErrorEngagement: false,
      messageEngagement: "",
      isErrorSkuList: false,
      errorSkuList: [],
      iCodeError: false,
    });
    if (engagementCodeException && engagementCodeException !== "") {
      setShowEngagementException(true);
    }
  }, [checkoutListData, reloadPage, checkoutListDataError, preventAutoFill]);

  const retiredSkuList = getRetiredSkuList(checkoutListData);
  useEffect(() => {
    if (isEmpty(engagementCode)) {
      setShowEngagementException(false);
      setShouldShowEnagagementException(false);
      setEngagementCodeException("");
      setEngagementError({
        ...engagementError,
        isErrorEngagement: false,
      });
      setDisableBtns(false);
    } else {
      const inputString = engagementCode.toUpperCase().trim();
      const firstChar = inputString.substring(0, 1);
      setShouldShowEnagagementException(false);
      if (firstChar === "I" && engagementCode.length === 10) {
        checkoutListData &&
          checkoutListData.Details?.forEach((detail: any) => {
            detail.SkuDetails?.forEach((sku: any) => {
              if (sku?.BillingTypeCd === "skubill_engagement") {
                setShouldShowEnagagementException(true);
              }

              if (sku?.SkuRelation?.length > 0) {
                sku.SkuRelation.forEach((relation: any) => {
                  if (relation?.BillingTypeCd === "skubill_engagement") {
                    setShouldShowEnagagementException(true);
                  }
                });
              }
            });
          });
      }
    }
  }, [engagementCode]);

  // fetch the sku config data for view details from the store and set it to the state which will be passed to the view details component
  useEffect(() => {
    dispatch(fetchSkuConfigData());
  }, [dispatch]);

  const validateEngagementCode = (engCode: string) => {
    const inputString = engCode.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);

    if (engagementCodeException.length === 0) {
      setEngagementExceptionError({
        ...engagementExceptionError,
        isErrorEngagement: false,
        messageEngagement: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
    }
    if (engCode.length === 0) {
      setEngagementError({
        ...engagementError,
        isErrorEngagement: false,
        messageEngagement: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      return;
    }
    if (engCode.length !== 10 || (firstChar !== "I" && firstChar !== "E")) {
      setEngagementError({
        ...engagementError,
        isErrorEngagement: true,
        messageEngagement: "Invalid Engagement Code",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      return;
    }

    if (firstChar !== "I") {
      setShowEngagementException(false);
      setEngagementCodeException("");
      setEngagementExceptionError({
        ...engagementExceptionError,
        isErrorEngagement: false,
        messageEngagement: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
    }

    const orderSkuList = getSkuListFromOrderBundleWithEngagement(
      checkoutListData,
      engagementCode,
      engagementCodeException,
    );
    if (orderSkuList.hasError) {
      const errorSkus: any =
        orderSkuList &&
        orderSkuList.OrderSkuErrorList &&
        //@ts-ignorets-ignore
        orderSkuList?.OrderSkuErrorList?.map((sku: any) => {
          return sku.SkuName || "";
        });
      setEngagementError({
        ...engagementError,
        isErrorEngagement: true,
        messageEngagement: "",
        isErrorSkuList: true,
        errorSkuList: errorSkus,
        iCodeError: true,
      });
      return false;
    }
    setOpportunityError("");
    setEngagementError({
      ...engagementError,
      isErrorEngagement: false,
      messageEngagement: "",
      isErrorSkuList: false,
      errorSkuList: [],
      iCodeError: false,
    });
  };

  const validateEngagementCodeException = (engCode: string) => {
    const inputString = engCode.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);
    if (engCode.length === 0) {
      setEngagementExceptionError({
        ...engagementExceptionError,
        isErrorEngagement: false,
        messageEngagement: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      return;
    }
    if (engCode.length !== 10 || firstChar !== "E") {
      setEngagementExceptionError({
        ...engagementExceptionError,
        isErrorEngagement: true,
        messageEngagement: "Invalid Engagement Code",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      return;
    }
  };

  useEffect(() => {
    const engagementCodeName = (engagementCode ?? "").trim().toUpperCase();
    const engagementCodeExceptionName = (engagementCodeException ?? "")
      .trim()
      .toUpperCase();

    const engItem = Array.isArray(engagementNameInStore)
      ? engagementNameInStore.find(
          (x) => (x.engagementCode ?? "").toUpperCase() === engagementCodeName,
        )
      : undefined;

    const excItem = Array.isArray(engagementNameExceptionInStore)
      ? engagementNameExceptionInStore.find(
          (x) =>
            (x.engagementCode ?? "").toUpperCase() ===
            engagementCodeExceptionName,
        )
      : undefined;

    if (engItem === undefined && excItem === undefined) {
      return;
    }

    const fromEng = engItem?.opportunityCode ?? "";
    const fromExc = excItem?.opportunityCode ?? "";

    const nextOpportunityCode = fromExc || fromEng;

    if (opportunityCode !== nextOpportunityCode && !isEmpty(opportunityCode)) {
    } else {
      if (
        showEngagementException &&
        engagementCodeException.length === 10 &&
        isEngagementCodeChanged
      ) {
        setOpportunityCode(nextOpportunityCode);
        setOpportunityName(excItem?.opportunityName ?? "");
        setIsEngagementCodeChanged(false);
      } else if (engagementCode.length === 10) {
        const orderSkuList = getSkuListFromOrderBundleWithEngagement(
          checkoutListData,
          engagementCode,
          engagementCodeException,
        );
        if (
          orderSkuList &&
          orderSkuList?.OrderSkuErrorList &&
          orderSkuList?.OrderSkuErrorList?.length > 0 &&
          orderSkuList.hasError &&
          isEmpty(engagementCodeException)
        ) {
          if (
            isEngagementCodeChanged &&
            engagementCode.toUpperCase().trim().startsWith("I") &&
            showEngagementException
          ) {
            setOpportunityCode(nextOpportunityCode);
            setOpportunityName(engItem?.opportunityName ?? "");
            setIsEngagementCodeChanged(false);
          }
        } else {
          if (isEngagementCodeChanged) {
            setOpportunityCode(nextOpportunityCode);
            setOpportunityName(engItem?.opportunityName ?? "");
            setIsEngagementCodeChanged(false);
          }
        }
      }
    }
  }, [
    checkoutListData,
    engagementNameInStore,
    engagementNameExceptionInStore,
    showEngagementException,
  ]);

  const validateOpportunityCode = (oppCode: string) => {
    const inputString = oppCode.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);
    if (oppCode.length === 0) {
      setOpportunityError("");
      return false;
    }
    if (oppCode.length < 9 || firstChar !== "O") {
      setOpportunityError("Invalid opportunity code");
      return false;
    }
    setOpportunityError("");
    return true;
  };

  useEffect(() => {
    async function getOpportunityName(opportunityCode: string) {
      const formData = {
        Action: "getOpportunityName",
        opportunityCode,
      };
      dispatch(fetchOpportunityName(formData));
    }

    const isDraft = checkoutListData?.OrderStatus === "order_draft";
    const opportunityCodeFromLocal = getOpportunityCodeFromLocal();
    const opportunityCodeFromApi = (
      checkoutListData?.OpportunityId || ""
    ).trim();
    const resolvedOpportunityCode =
      isDraft && opportunityCodeFromLocal
        ? opportunityCodeFromLocal
        : opportunityCodeFromApi;

    if (resolvedOpportunityCode) {
      const isOpportunityCodeValid = validateOpportunityCode(
        resolvedOpportunityCode,
      );
      if (isOpportunityCodeValid) {
        getOpportunityName(resolvedOpportunityCode);
      } else {
        setOpportunityName("");
        dispatch(resetOpportunityNameState());
      }
    } else {
      setOpportunityName("");
      setOpportunityError("");
      dispatch(resetOpportunityNameState());
    }
  }, [checkoutListData?.OrderStatus, checkoutListData?.OpportunityId]);

  useEffect(() => {
    const opportunityFromStore = Array.isArray(opportunityNameInStore)
      ? opportunityNameInStore[0]?.opportunityName
      : "";
    setOpportunityName(opportunityFromStore ?? "");
    setOpportunityError(opportunityNameError ?? "");
  }, [opportunityNameInStore, opportunityNameError]);

  const resetOpportunityName = (opCode: string) => {
    setOpportunityName("");
    setOpportunityError("");
    if (opCode.length < 9) {
      return;
    }
    if (
      Array.isArray(opportunityNameInStore) &&
      opportunityNameInStore[0]?.opportunityCode &&
      opCode === opportunityNameInStore[0].opportunityCode
    ) {
      const opportunityFromStore = Array.isArray(opportunityNameInStore)
        ? opportunityNameInStore[0]?.opportunityName
        : "";
      setOpportunityName(opportunityFromStore ?? "");
    } else {
      dispatch(resetOpportunityNameState());
      async function getOpportunityName() {
        if (opCode) {
          const formData = {
            Action: "getOpportunityName",
            opportunityCode: opCode,
          };
          dispatch(fetchOpportunityName(formData));
        }
      }
      getOpportunityName();
    }
  };

  useEffect(() => {
    async function getEngagementName() {
      const formData = {
        Action: "getEngagementName",
        EngagementCode: engagementCode,
      };
      dispatch(fetchEngagementName(formData));
    }
    if (engagementName.length === 10) {
      getEngagementName();
      validateEngagementCode(engagementCode);
    } else {
      setEngagementName("");
      dispatch(resetEngagementNameState());
    }
  }, [engagementName]);

  useEffect(() => {
    async function getEngagementName() {
      const formData = {
        Action: "getEngagementName",
        EngagementCodeException: engagementCodeException,
      };
      dispatch(fetchEngagementNameException(formData));
    }
    if (engagementNameException.length === 10) {
      getEngagementName();
      validateEngagementCodeException(engagementNameException);
      setEngagementExceptionError({
        ...engagementExceptionError,
        isErrorEngagement: false,
        messageEngagement: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      if (engagementName.length === 10) {
        setEngagementError({
          ...engagementError,
          isErrorEngagement: false,
          messageEngagement: "",
          isErrorSkuList: false,
          errorSkuList: [],
          iCodeError: false,
        });
      }
    } else {
      setEngagementNameException("");
      dispatch(resetEngagementNameExceptionState());
    }
  }, [engagementNameException]);

  useEffect(() => {
    if (
      checkOutListState &&
      checkOutListState !== null &&
      isChangedActive &&
      !disableBtns
    ) {
      if (checkOutListState?.OrderStatus === "order_estimate") {
        return;
      }
      const OrderSkuList = getSkuListFromOrderBundle(checkOutListState);
      const OrderUpdateobj = {
        Action: "updateOrder",
        OrderId: checkOutListState?.OrderId || 0,
        Description: checkOutListState?.Description || "",
        OrderSku: OrderSkuList,
      };

      const updateOrderBundleListAsync = async (
        orderUpdateObj: OrderUpdateObj,
      ) => {
        try {
          const response = await dispatch(
            updateOrderBundleList(orderUpdateObj),
          );
          if (response.meta.requestStatus === "fulfilled") {
            setIsChangedActive(false);
          } else {
            console.log("There is a issue in updating Order bundle");
            setIsChangedActive(false);
          }
          clearTimeout(intervalId);
        } catch (error) {
          console.error("Error updating order bundle:", error);
          setIsChangedActive(false);
          clearTimeout(intervalId);
        }
      };
      const intervalId = setTimeout(function () {
        updateOrderBundleListAsync(OrderUpdateobj);
      }, 3000);

      return () => clearTimeout(intervalId);
    }
  }, [checkOutListState, dispatch, isChangedActive, disableBtns]);

  const isEngagementException = () => {
    const orderSkuList = getSkuListFromOrderBundleWithEngagement(
      checkoutListData,
      engagementCode,
      engagementCodeException,
    );
    if (
      orderSkuList &&
      orderSkuList?.OrderSkuErrorList &&
      orderSkuList?.OrderSkuErrorList?.length > 0 &&
      orderSkuList.hasError
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const isExceptionEngagementActive = isEngagementException();
    if (
      (!isExceptionEngagementActive && engagementCodeException === "") ||
      (opportunityCode === "" &&
        engagementCodeException === "" &&
        isExceptionEngagementActive)
    ) {
      const nextOpportunityCode = getNextOpportunityCode(
        isExceptionEngagementActive,
        engagementCode,
        engagementCodeException,
        engagementNameInStore,
        engagementNameExceptionInStore,
      );
      if (
        opportunityCode !== nextOpportunityCode?.opportunityCode &&
        !isEmpty(opportunityCode) &&
        !isEmpty(nextOpportunityCode?.opportunityCode)
      ) {
        setOpportunityMismatchError({
          ...opportunityMismatchError,
          isErrorOpportunity: true,
          messageOpprotunity: "Opportunity code mismatch",
          engagement: {
            code: nextOpportunityCode?.engagementCode || "",
            name: nextOpportunityCode?.engagementName || "",
          },
          opportunity: {
            code: opportunityCode,
            name: opportunityName,
          },
          nextOpportunity: {
            code: nextOpportunityCode?.opportunityCode ?? "",
            name: nextOpportunityCode?.opportunityName ?? "",
          },
        });
      }
    }
    if (showEngagementException && engagementNameExceptionInStore !== null) {
      const nextOpportunityCode = getNextOpportunityCode(
        showEngagementException,
        engagementCode,
        engagementCodeException,
        engagementNameInStore,
        engagementNameExceptionInStore,
      );
      if (
        opportunityCode !== nextOpportunityCode?.opportunityCode &&
        !isEmpty(opportunityCode) &&
        !isEmpty(nextOpportunityCode?.opportunityCode)
      ) {
        setOpportunityMismatchError({
          ...opportunityMismatchError,
          isErrorOpportunity: true,
          messageOpprotunity: "Opportunity code mismatch",
          engagement: {
            code: nextOpportunityCode?.engagementCode || "",
            name: nextOpportunityCode?.engagementName || "",
          },
          opportunity: {
            code: opportunityCode,
            name: opportunityName,
          },
          nextOpportunity: {
            code: nextOpportunityCode?.opportunityCode ?? "",
            name: nextOpportunityCode?.opportunityName ?? "",
          },
        });
      }
    }
  }, [
    engagementNameInStore,
    engagementNameLoading,
    showEngagementException,
    engagementNameExceptionInStore,
  ]);

  const getOrderDetails = (checkOutListState: ResponseDetails | null) => {
    if (!checkOutListState || checkOutListState === null) {
      return [];
    }
    if (checkOutListState && checkOutListState !== null) {
      if (
        !checkoutListData ||
        checkoutListData === null ||
        checkOutListState?.Details.length === 0
      ) {
        return [];
      }
      const orderSkus: OrderSkuDetails[] = [];
      checkOutListState.Details.forEach((orderDataRow: any) => {
        const orderSkusResponse = getOrderSkuDetails(orderDataRow.SkuDetails);
        orderSkusResponse.forEach((orderSku: any) => {
          orderSkus.push(orderSku);
        });
      });
      return orderSkus;
    }
  };

  const updateOrderBundleHandler = async () => {
    if (!checkOutListState || checkOutListState === null) {
      console.error("No order details available to update.");
      return;
    }
    if (orderName === "") {
      console.error("Order Name cannot be empty.");
      setIsOrderUpdateWarning(true);
      return;
    }

    const orderDetails = getOrderDetails(checkOutListState);
    if (
      orderDetails === undefined ||
      orderDetails.length === 0 ||
      orderDetails === null
    ) {
      console.error("No SKUs available to update.");
      return;
    }
    const updateOrderRequestDetails = {
      Action: "updateDescription",
      OrderId: checkOutListState?.OrderId || 0,
      Description: orderName,
    };

    if (updateOrderRequestDetails === undefined) {
      console.error("No SKUs available to update.");
      return;
    }

    const response = await dispatch(
      updateOrderBundle(updateOrderRequestDetails),
    );

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    if (response.payload.Code !== 200) {
      setIsOrderUpdateWarning(true);
      return;
    } else {
      setCheckOutListState({
        ...checkOutListState,
        Description: updateOrderRequestDetails.Description,
      });
      setIsOrderEdit(false);
      setIsOrderUpdateWarning(false);
    }
  };

  const popupCloseHandler = () => {
    setIsOrderUpdateWarning(false);
    setIsOrderEdit(false);
    setOrderName(checkOutListState?.Description || "");
  };

  const getTotalOrderAmount = (checkoutListData: any) => {
    if (
      !checkoutListData ||
      checkoutListData === null ||
      checkoutListData?.length === 0
    ) {
      return 0;
    }
    if (checkoutListData && checkoutListData !== null) {
      let totalAmount = 0;
      if (
        !checkoutListData ||
        checkoutListData === null ||
        checkoutListData?.Details?.length === 0
      ) {
        return 0;
      }
      checkoutListData.Details.forEach((orderDataRow: any) => {
        orderDataRow.SkuDetails.forEach((sku: any) => {
          const quantity = sku?.OrderQuantity || 0;
          const cost = sku?.CostMetricCost || 0;
          const duration = sku?.OrderInterval || 0;
          totalAmount += cost * quantity * duration;
          if (sku?.SkuRelation && sku?.SkuRelation?.length > 0) {
            sku.SkuRelation.forEach((relation: any) => {
              const quantity = relation?.OrderQuantity || 0;
              const cost = relation.CostMetricCost || 0;
              const duration = relation.OrderInterval || 0;
              totalAmount += cost * quantity * duration;
            });
          }
        });
      });
      return totalAmount.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    }
  };
  const memorisedTotal = useMemo(
    () => getTotalOrderAmount(checkOutListState),
    [checkOutListState],
  );

  const memorisedTotalVariable: string = useMemo(
    () =>
      getTotalOrderAmountVariable(checkOutListState?.Details || [], configData),
    [checkOutListState, configData],
  );

  useEffect(() => {
    const cleanNumber = memorisedTotalVariable.replace(/[$,]/g, "");
    if (!isNaN(Number(cleanNumber))) {
      setShowVariableCost(Number(cleanNumber) > 0);
    }
  }, [memorisedTotalVariable]);

  const onTabChange = (key: number) => {
    setSelectedTab(key);
  };

  const myestimateBreadcrub = [
    {
      label: "External Submission",
      value: "Home",
      elementKey: "submission",
      text: "Home",
      url: `/`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "My Workspace",
      elementKey: "submission",
      text: "My Workspace",
      url: `/my-workspace`,
      disabled: false,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "Checkout",
      elementKey: "submission",
      text: "My Estimate",
      url: `/my-workspace/my-estimates`,
      disabled: false,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
  ];

  if (viewMode && !isOrderDeleted && !noOrderAccess) {
    const estimateName = TextAbstract(checkOutListState?.Description || "", 20);
    const estimateLink = {
      label: "External Submission",
      value: estimateName,
      elementKey: "submission",
      text: estimateName,
      url: `/${estimateName}`,
      disabled: true,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    };
    myestimateBreadcrub.push(estimateLink);
  }

  const breadcrumbItems = viewMode
    ? myestimateBreadcrub
    : [
        {
          label: "External Submission",
          value: "Home",
          elementKey: "submission",
          text: "Home",
          url: `/`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          label: "External Submission",
          value: "Checkout",
          elementKey: "submission",
          text: "Cart Preview",
          url: `/checkout`,
          disabled: true,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
      ];

  const handleSyncCheckoutPage = async (
    bypassChangeActive: boolean = false,
  ) => {
    if (!isChangedActive && !bypassChangeActive) {
      return true;
    } else {
      if (checkOutListState !== undefined) {
        if (
          checkOutListState?.OrderStatus === "order_estimate" &&
          !bypassChangeActive
        ) {
          setIsChangedActive(false);
          return true;
        }
        const OrderSkuList = getSkuListFromOrderBundle(checkOutListState);
        const OrderUpdateobj = {
          Action: "updateOrder",
          OrderId: checkOutListState?.OrderId || 0,
          Description: checkOutListState?.Description || "",
          OrderSku: OrderSkuList,
        };
        const updateOrderBundleListAsync = async (
          orderUpdateObj: OrderUpdateObj,
        ) => {
          try {
            const response = await dispatch(
              updateOrderBundleList(orderUpdateObj),
            );
            if (response.meta.requestStatus === "fulfilled") {
              setIsChangedActive(false);
              return true;
            } else {
              console.log("There is a issue in updating Order bundle");
              setIsChangedActive(false);
              return true;
            }
          } catch (error) {
            console.error("Error updating order bundle:", error);
            setIsChangedActive(false);
            return true;
          }
        };
        await updateOrderBundleListAsync(OrderUpdateobj);
      }
    }
  };

  const handleOrderNow = async () => {
    if (
      disableBtns ||
      engagementError.isErrorEngagement ||
      engagementError.isErrorOpportunity ||
      engagementExceptionError.isErrorEngagement
    ) {
      return;
    }
    setUnexpectedError(false);
    if (isEmpty(engagementCode)) {
      setEngagementError({
        ...engagementError,
        isErrorEngagement: true,
        isErrorOpportunity: false,
        messageEngagement: "Enter engagement code to place order",
        messageOpprotunity: "",
        isErrorSkuList: false,
        errorSkuList: [],
        iCodeError: false,
      });
      return false;
    }

    await handleSyncCheckoutPage(true);
    try {
      const orderSkuList = getSkuListFromOrderBundleWithEngagement(
        checkoutListData,
        engagementCode,
        engagementCodeException,
      );
      if (
        orderSkuList &&
        orderSkuList?.OrderSkuErrorList &&
        orderSkuList?.OrderSkuErrorList?.length > 0 &&
        orderSkuList.hasError
      ) {
        setShowEngagementException(true);
      }
      if (orderSkuList.hasError) {
        const errorSkus: any =
          orderSkuList &&
          orderSkuList.OrderSkuErrorList &&
          //@ts-ignorets-ignore
          orderSkuList?.OrderSkuErrorList?.map((sku: any) => {
            return sku.SkuName || "";
          });
        setEngagementError({
          ...engagementError,
          isErrorEngagement: true,
          messageEngagement: "",
          isErrorSkuList: true,
          errorSkuList: errorSkus,
          iCodeError: true,
        });
        return false;
      }
      const formData = {
        OpportunityId: opportunityCode,
        Action: "SaveOrder",
        OrderId: checkoutListData?.OrderId || 0,
        OrderSku: orderSkuList.OrderSkuList,
      };
      setIsLoadingOrderNow(true);
      //@ts-ignore
      const response = await dispatch(callOrderNow(formData));
      setIsLoadingOrderNow(false);
      if (response.payload.Status === "success") {
        setIsOrder(true);
        setOrderData(response.payload.Data);
        removeOrderIdFromLocal();
        removeOpportunityCodeFromLocal();
      } else {
        const responseMessage = response.payload.message.toLowerCase();
        let opportunityPos = responseMessage.search("opportunity code");
        let opportunityError = false;
        if (opportunityPos !== -1) {
          opportunityError = true;
        }
        let position = responseMessage.search("engagement code");
        if (position === -1 && opportunityPos === -1) {
          setUnexpectedError(true);
          return false;
        }
        if (position === -1) {
          setEngagementError({
            ...engagementError,
            isErrorEngagement: false,
            messageEngagement: "",
            isErrorSkuList: false,
            //@ts-ignore
            errorSkuList: [],
            iCodeError: false,
            isErrorOpportunity: opportunityError,
            messageOpprotunity: opportunityError
              ? "Opportunity ID not found"
              : "",
          });
          return false;
        }
        const errorListFromResponse = getEngagementErrorFromResponse(
          checkOutListState,
          response.payload.payload,
          engagementCode,
          engagementCodeException,
          showEngagementException,
        );
        const errorSkus = errorListFromResponse.OrderSkuList.map((sku) => {
          //@ts-ignore
          return sku.SkuName || "";
        });
        const errorSkusException =
          errorListFromResponse.OrderSkuListException.map((sku) => {
            //@ts-ignore
            return sku.SkuName || "";
          });
        setEngagementError({
          ...engagementError,
          isErrorEngagement: true,
          messageEngagement: "",
          isErrorSkuList: true,
          //@ts-ignore
          errorSkuList: errorSkus,
          iCodeError: false,
        });
        if (errorSkusException.length > 0) {
          setEngagementExceptionError({
            ...engagementExceptionError,
            isErrorEngagement: true,
            messageEngagement: "",
            isErrorSkuList: true,
            //@ts-ignore
            errorSkuList: errorSkusException,
            iCodeError: false,
          });
        }
      }
    } catch (error) {
      console.error("Failed to place order:", error);
    }
  };

  const isOpportunityCodeMismatchWithICode = () => {
    if (isEmpty(engagementCode)) {
      return false;
    }
    const isExceptionEngagementActive = isEngagementException();
    if (isExceptionEngagementActive && engagementCodeException === "") {
      const nextOpportunityCode = getNextOpportunityCode(
        false,
        engagementCode,
        engagementCodeException,
        engagementNameInStore,
        engagementNameExceptionInStore,
      );
      if (
        opportunityCode !== nextOpportunityCode?.opportunityCode &&
        !isEmpty(opportunityCode) &&
        !isEmpty(nextOpportunityCode?.opportunityCode)
      ) {
        setOpportunityMismatchError({
          ...opportunityMismatchError,
          isErrorOpportunity: true,
          messageOpprotunity: "Opportunity code mismatch",
          engagement: {
            code: nextOpportunityCode?.engagementCode || "",
            name: nextOpportunityCode?.engagementName || "",
          },
          opportunity: {
            code: opportunityCode,
            name: opportunityName,
          },
          nextOpportunity: {
            code: nextOpportunityCode?.opportunityCode ?? "",
            name: nextOpportunityCode?.opportunityName ?? "",
          },
        });
        setOpportunityCodeMistachWithIcode(true);
        return true;
      }
    }
    return opportunityCodeMistachWithIcode;
  };

  const handleSaveEstimate = async (
    bypassSetEstimate: boolean = false,
    skipMismatchCheck: boolean = false,
    overrideOpportunityCode?: string,
  ) => {
    if (disableBtns) {
      return;
    }
    if (!skipMismatchCheck) {
      const ispportunityCodeMismatch = isOpportunityCodeMismatchWithICode();
      if (ispportunityCodeMismatch) {
        return false;
      }
    }
    setUnexpectedError(false);
    await handleSyncCheckoutPage(true);
    const orderSkuList = getSkuListFromOrderBundleWithEngagementEstimate(
      checkoutListData,
      engagementCode,
      engagementCodeException,
    );
    try {
      const formData = {
        OpportunityId: overrideOpportunityCode || opportunityCode,
        Action: "SaveEstimate",
        OrderId: checkoutListData?.OrderId || 0,
        OrderSku: orderSkuList.OrderSkuList,
      };
      !bypassSetEstimate && setIsLoadingEstimate(true);
      //@ts-ignore
      const response = await dispatch(callSaveEstimate(formData));
      setIsLoadingEstimate(false);
      if (response.payload.Status === "success") {
        !bypassSetEstimate && setIsSaveEstimate(true);
        setSaveEstimateData(response.payload.Data);
        !bypassSetEstimate && removeOrderIdFromLocal();
        dispatch(resetEstimateChangeState() as any);
        removeOpportunityCodeFromLocal();
        return true;
      } else {
        const responseMessage = response.payload.message.toLowerCase();
        let opportunityPos = responseMessage.search("opportunity code");
        let opportunityError = false;
        if (opportunityPos !== -1) {
          opportunityError = true;
        }
        let position = responseMessage.search("engagement code");
        if (position === -1 && opportunityPos === -1) {
          setUnexpectedError(true);
          return false;
        }
        if (position === -1) {
          setEngagementError({
            ...engagementError,
            isErrorEngagement: false,
            messageEngagement: "",
            isErrorSkuList: false,
            //@ts-ignore
            errorSkuList: [],
            iCodeError: false,
            isErrorOpportunity: opportunityError,
            messageOpprotunity: opportunityError
              ? "Opportunity ID not found"
              : "",
          });
          return false;
        }
        const errorListFromResponse = getEngagementErrorFromResponse(
          checkOutListState,
          response.payload.payload,
          engagementCode,
          engagementCodeException,
          showEngagementException,
        );

        const errorSkus = errorListFromResponse.OrderSkuList.map((sku) => {
          //@ts-ignore
          return sku.SkuName || "";
        });
        const errorSkusException =
          errorListFromResponse.OrderSkuListException.map((sku) => {
            //@ts-ignore
            return sku.SkuName || "";
          });
        setEngagementError({
          ...engagementError,
          isErrorEngagement: true,
          messageEngagement: "",
          isErrorSkuList: true,
          //@ts-ignore
          errorSkuList: errorSkus,
          iCodeError: false,
          isErrorOpportunity: opportunityError,
          messageOpprotunity: opportunityError
            ? "Opportunity ID not found"
            : "",
        });
        if (errorSkusException.length > 0) {
          setEngagementExceptionError({
            ...engagementExceptionError,
            isErrorEngagement: true,
            messageEngagement: "",
            isErrorSkuList: true,
            //@ts-ignore
            errorSkuList: errorSkusException,
            iCodeError: false,
          });
        }
        return false;
      }
    } catch (error) {
      console.error("Failed to place order:", error);
      return false;
    }
  };
  const getEngagementError = (
    isEngagementCodeError: boolean,
    engError: EngagementError,
  ) => {
    if (engagementNameLoading || engagementCode.length === 0) {
      if (engagementCode.length === 0 && isEngagementCodeError) {
        return (
          <>
            <MotifErrorMessage
              aria-live="assertive"
              role="alert"
              id="aria-error-primaryList"
              className="error-message-truncate"
            >
              <div className="sku-error-title">{`${engagementError.messageEngagement}`}</div>
            </MotifErrorMessage>
          </>
        );
      }
      return null;
    }
    if (engagementNameError) {
      return (
        <>
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-primaryList"
            className="error-message-truncate"
          >
            <div className="sku-error-title">{`${engagementNameError}`}</div>
          </MotifErrorMessage>
        </>
      );
    }
    const inputString = engagementCode.toUpperCase().trim();
    const firstChar = inputString.substring(0, 1);
    const errorString =
      engError.iCodeError && firstChar === "I"
        ? ` can't be billed with an  I-Code`
        : ` can't be billed under this code`;
    if (engagementError.errorSkuList.length === 1) {
      return (
        <div className="eng-error">
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-primaryList"
          >
            <div className="sku-error-title">{`${engagementError.errorSkuList[0]}`}</div>
            {` SKU ${errorString}`}
          </MotifErrorMessage>
        </div>
      );
    }
    let engagementTooltipError = "";

    if (isEngagementCodeError && engagementError?.isErrorSkuList) {
      engagementTooltipError = `The following ${engagementError.errorSkuList.length} SKUs ${errorString}:\n
       `;

      return (
        <>
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-primaryList"
          >
            <EngagementErrorTooltip
              message={engagementTooltipError}
              triggerString={`${engagementError.errorSkuList.length} SKUs`}
              errorSkuList={engagementError.errorSkuList}
            />{" "}
            {errorString ? errorString.replace(/ /g, "\u00A0") : ""}
          </MotifErrorMessage>
        </>
      );
    } else if (isEngagementCodeError && !engagementError?.isErrorSkuList) {
      return (
        <MotifErrorMessage
          aria-live="assertive"
          role="alert"
          id="aria-error-primaryList"
        >
          {engagementError.messageEngagement}
        </MotifErrorMessage>
      );
    } else {
      return undefined;
    }
  };

  const getEngagementErrorException = () => {
    if (engagementCodeException.length === 0) {
      return null;
    }
    if (isEngagementCodeErrorException || engagementNameExceptionError) {
      return (
        <>
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-primaryList"
            className="error-message-truncate"
          >
            <div className="sku-error-title">
              {engagementExceptionError.messageEngagement ||
                (engagementNameExceptionError
                  ? `${engagementNameExceptionError}`
                  : "Invalid Engagement Code")}
            </div>
          </MotifErrorMessage>
        </>
      );
    }
    return null;
  };

  const getInvaidErrorHandleSave = () => {
    if (unexpectedError) {
      return (
        <>
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-primaryList"
            className="error-message-truncate"
          >
            <div className="sku-error-title">
              Unexpected Error While saving. Please try again later.
            </div>
          </MotifErrorMessage>
        </>
      );
    }
    return null;
  };

  const renderEmptyCheckout = () => {
    if (checkoutListLoading && !isNoOrder) {
      return <Loader />;
    }
    if (noOrderAccess) {
      return (
        <div className="checkout-empty-state">
          <img src={noOrderAccessImg} alt="Empty Checkout Page" />
          <div>
            <p>{NO_ACCESS_ESTIMATE}</p>
            <p className="suggestion-text">{NO_ACCESS_ESTIMATE_SUGGESTION}</p>
            <p className="suggestion-text">{NO_ACCESS_ESTIMATE_SUGGESTION2}</p>
          </div>
          <Button
            variant="primary"
            className="checkout-empty-state-btn"
            onClickHandler={() => navigate("/my-workspace/my-estimates")}
            label="Open My Estimates"
          />
        </div>
      );
    } else if (isOrderDeleted) {
      return (
        <div className="checkout-empty-state">
          <img src={noOrderAccessImg} alt="Empty Checkout Page" />
          <div>
            <p>{DELETE_ESTIMATE}</p>
            <p className="suggestion-text">{DELETED_ESTIMATE_SUGGESTION}</p>
            <p className="suggestion-text">{DELETED_ESTIMATE_SUGGESTION2}</p>
            <p className="suggestion-text">{DELETED_ESTIMATE_SUGGESTION3}</p>
          </div>
          <Button
            variant="primary"
            className="checkout-empty-state-btn"
            onClickHandler={() => navigate("/my-workspace/my-estimates")}
            label="Open My Estimates"
          />
        </div>
      );
    } else {
      return (
        <div className="checkout-empty-state">
          <img src={checkoutEmptyImg} alt="Empty Checkout Page" />
          {errorcheckoutList ? (
            <div className="error">{errorcheckoutList}</div>
          ) : (
            <>
              <p>You don’t have anything in your checkout yet.</p>
              <p className="suggestion-text">
                Add products to create your order bundle first, Once you do,
                they’ll appear here.
              </p>
            </>
          )}

          <Button
            variant="primary"
            className="checkout-empty-state-btn"
            onClickHandler={() => navigate("/marketplace")}
            label="Go to Marketplace"
          />
        </div>
      );
    }
  };

  const getLastSyncDateAndTime = () => {
    if (!checkOutListState || checkOutListState === null) {
      return "";
    }
    const lastSyncDate = checkOutListState?.CRMSaveDtm;
    return isEmpty(lastSyncDate)
      ? "Order syncs to CRM once saved as an estimate"
      : `Last saved to CRM ${getSyncFormattedDate(lastSyncDate)} (UTC)`;
  };

  if (isOrder) {
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      <OrderPlaced orderData={orderData} configData={configData} />
    );
  }

  if (isSaveEstimate) {
    return (
      <OrderExpected
        orderData={saveEstimateData}
        setIsSaveEstimate={setIsSaveEstimate}
        configData={configData}
      />
    );
  }

  const isCheckoutEmpty =
    checkOutListState &&
    checkOutListState !== null &&
    "Details" in checkOutListState &&
    checkOutListState?.Details?.length > 0 &&
    !isNoOrder &&
    currentOrderId > 0
      ? false
      : true;
  if (checkoutListLoading && currentOrderId > 0) {
    return <Loader />;
  }

  const isOpportunityCodeError = engagementError.isErrorOpportunity;
  const isEngagementCodeError = engagementError.isErrorEngagement;
  const isEngagementCodeErrorException =
    engagementExceptionError.isErrorEngagement;
  return (
    <>
      <div className="checkout-detail-wrapper">
        <section
          className={`checkout-content-header commercial-hub-header-banner-lg ${
            noOrderAccess || isOrderDeleted ? "hide" : ""
          }`}
        >
          <div className="checkout-cost-setup-bredcrumb">
            <Breadcrumb
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          {isOrderEdit && !viewMode ? (
            <div className="order-name-grid-input">
              <InputBox
                aria-label="Order Name"
                name="orderName"
                label="Order Name"
                placeholder="Order Name"
                className="order-name-input"
                type="text"
                value={orderName}
                onChange={(e) => {
                  if (isStringHavingSpecialChars(e.target.value)) {
                    return;
                  }
                  setOrderName(removeEmojis(e.target.value));
                }}
                onBlur={updateOrderBundleHandler}
                hideClearButton={true}
              />
            </div>
          ) : (
            <div className="order-name-grid">
              <>
                {isCheckoutEmpty || currentOrderId < 0 ? (
                  <>
                    <h1 className="checkout-title">Order Bundle</h1>
                  </>
                ) : (
                  <>
                    <MotifTruncate
                      maxLines={1}
                      maxWidth={orderNameTruncateMaxWidth}
                    >
                      {checkOutListState?.Description || ""}
                    </MotifTruncate>
                    {!viewMode && (
                      <Button
                        label=""
                        className="editOdername"
                        onClickHandler={() => setIsOrderEdit(true)}
                      >
                        <MotifIcon src={IconoirEditPencil} strokeWidth="24" />
                      </Button>
                    )}
                  </>
                )}
              </>
            </div>
          )}

          <div className="checkout-description">
            {ORDER_BUNDLE_DESCRIPTION.length > 250 ? (
              <MotifTooltip
                contentClassName="tooltip-content"
                allowClick
                allowHover
                id="tooltip-header-banner"
                placement="auto"
                trigger={ORDER_BUNDLE_DESCRIPTION.slice(0, 250).concat(" ...")}
                usePortal
                variant="default"
              >
                {ORDER_BUNDLE_DESCRIPTION}
              </MotifTooltip>
            ) : (
              ORDER_BUNDLE_DESCRIPTION
            )}
          </div>
        </section>
        <section
          className={`checkout-tab-content ${
            noOrderAccess || isOrderDeleted ? "hide" : ""
          }`}
        >
          <MotifTabNavigation
            defaultActiveKey={0}
            orientation="horizontal"
            size="md"
            variant="default"
          >
            <MotifTabControl onClick={() => onTabChange(0)}>
              {CHECKOUT}
            </MotifTabControl>
            {/* <MotifTabControl onClick={() => onTabChange(1)}>
              {SAVED_FOR_LATER}
            </MotifTabControl> */}
          </MotifTabNavigation>
        </section>
        {noOrderAccess || isOrderDeleted || isCheckoutEmpty ? (
          renderEmptyCheckout()
        ) : (
          <section className="checkout-content-body">
            {selectedTab === 0 && (
              <>
                <div className="checkout-content-body-ct-marketplace">
                  <div
                    className={`sku-retired-error-message ${
                      retiredSkuList.length === 0 ? "hide" : ""
                    }`}
                  >
                    <MotifIcon
                      src={IconoirWarningCircle}
                      className="warning-icon"
                    />
                    <div className="error-message">
                      {RETIRED_SKU_IN_CHECKOUT_MESSAGE}
                    </div>
                  </div>
                  {viewMode && (
                    <MotifToast
                      className="checkout-view-only"
                      onClose={() => {}}
                      variant="info"
                    >
                      <div className="error-message">
                        {VIEW_CHECKOUT_WARNING}{" "}
                        {checkoutListData?.CreatedByEmail || ""}.
                      </div>
                    </MotifToast>
                  )}
                  <div>
                    {!isCheckoutEmpty &&
                      checkOutListState?.Details?.map((orderDataRow) => {
                        const productId =
                          orderDataRow?.SkuDetails?.length > 0
                            ? orderDataRow?.SkuDetails[0]?.ProductId
                            : "";
                        return (
                          <OrderCard
                            key={orderDataRow.ProductName}
                            productName={orderDataRow.ProductName}
                            productId={productId}
                            assetAdvice={orderDataRow.AssetAdvice}
                            skuDetails={orderDataRow.SkuDetails.map(
                              (sku: any) => ({
                                ...sku,
                                Indexation: sku.Indexation ?? 0,
                                CostMetricNSR: sku.CostMetricNSR ?? 0,
                                StatusName: sku.StatusName ?? "",
                              }),
                            )}
                            checkOutListState={checkOutListState}
                            setCheckOutListState={setCheckOutListState}
                            setReloadPage={setReloadPage}
                            isChangedActive={isChangedActive}
                            setIsChangedActive={setIsChangedActive}
                            setDisableBtns={setDisableBtns}
                            disableBtns={disableBtns || viewMode}
                            setShowEngagementException={
                              setShowEngagementException
                            }
                            onOrderUpdated={handleOrderUpdated}
                            retiredSkuList={retiredSkuList}
                            viewMode={viewMode}
                            configData={configData}
                          />
                        );
                      })}
                  </div>
                </div>
                <div className="checkout-content-body-view-details">
                  <div className="cost-estimate-grid">
                    <div className="cost-estimate-title">Total cost</div>
                    <div>
                      <div className="cost-estimate-value order-total">
                        {memorisedTotal}{" "}
                      </div>
                      {showVariableCost && (
                        <div className="cost-estimate-value-support">
                          <div className="variable-cost-info-grid">
                            <div>{memorisedTotalVariable} Variable cost</div>
                            <InfoTooltip
                              description={variableTotalInfo()}
                              info={true}
                              id="variable-total-cost-info"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="cost-breakdown-grid">
                    <div className="cost-breakdown-container">
                      <div>
                        <MotifAccordion
                          variant="functional"
                          useChevronIcon
                          className="cost-breakdown-accordian"
                        >
                          <MotifAccordionTrigger className="cost-breakdown-title-grid">
                            Cost breakdown
                          </MotifAccordionTrigger>
                          <MotifAccordionContent>
                            {!isCheckoutEmpty &&
                              checkOutListState?.Details.map(
                                (orderDataRow, index) => (
                                  <Accordian
                                    key={index}
                                    skuDetails={orderDataRow.SkuDetails}
                                    productName={orderDataRow.ProductName}
                                  />
                                ),
                              )}
                          </MotifAccordionContent>
                        </MotifAccordion>
                      </div>
                    </div>
                    <div className="cost-breakdown-table opportunity">
                      <div className="discription-row InputElement">
                        <label htmlFor="opportunityCode">Opportunity ID</label>
                        <div className="opportunity-grid">
                          <InputBox
                            aria-label="Opportunity ID"
                            name="opportunityCode"
                            label="Opportunity ID"
                            placeholder="Enter opportunity ID"
                            className="opportunity-name-input"
                            type="text"
                            readonly={
                              viewMode ||
                              (!showEngagementException &&
                                engagementCode.trim().length === 10) ||
                              (showEngagementException &&
                                engagementCodeException.trim().length === 10)
                            }
                            value={opportunityCode}
                            prefix={
                              <MotifIcon
                                src={IconoirPolarSh}
                                className={`opportunityCode-icon ${
                                  isOpportunityCodeError ? "error" : ""
                                }`}
                              />
                            }
                            suffix={
                              isOpportunityCodeError ? (
                                <MotifIcon
                                  src={IconoirWarningCircle}
                                  className="opportunityCode-icon error"
                                />
                              ) : (
                                ""
                              )
                            }
                            onChange={(e) => {
                              setEngagementError({
                                ...engagementError,
                                isErrorOpportunity: false,
                                messageOpprotunity: "",
                                isErrorSkuList: false,
                                errorSkuList: [],
                              });
                              setOpportunityCode(e.target.value);
                              resetOpportunityName(e.target.value);
                              if (e.target.value.trim() === "") {
                                setOpportunityName("");
                                setOpportunityError("");
                              }
                            }}
                            hideClearButton={true}
                            error={
                              isOpportunityCodeError
                                ? {
                                    isError: engagementError.isErrorOpportunity,
                                    message: engagementError.messageOpprotunity,
                                  }
                                : undefined
                            }
                          />
                          {isOpportunityCodeError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {engagementError?.messageOpprotunity}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                          <div
                            className={`opportunity-name ${
                              opportunityName && !opportunityError ? "" : "hide"
                            }`}
                          >
                            {opportunityName
                              ? renderEngagementName(opportunityName)
                              : ""}
                          </div>
                          {opportunityNameLoading && <Loader />}
                        </div>
                        {opportunityError ? (
                          <MotifErrorMessage
                            aria-live="assertive"
                            role="alert"
                            id="aria-error-primaryList"
                          >
                            {opportunityError}
                          </MotifErrorMessage>
                        ) : (
                          ""
                        )}
                        {checkoutListData?.IsCRMSyncRequired && (
                          <span className="lastsync-time">
                            {getLastSyncDateAndTime()}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="cost-breakdown-table engagementCode">
                      <div className="discription-row InputElement">
                        <label htmlFor="engagementCode">Engagement Code</label>
                        <div className="engagement-grid">
                          <InputBox
                            aria-label="Engagement Code"
                            name="engagementCode"
                            label="Engagement Code"
                            placeholder="Enter a valid engagement code"
                            className="engagementCode-name-input"
                            type="text"
                            readonly={viewMode}
                            value={engagementCode}
                            onChange={(e) => {
                              setEngagementCode(e.target.value.trim());
                              if (engagementError.isErrorEngagement) {
                                setEngagementError({
                                  ...engagementError,
                                  isErrorEngagement: false,
                                  messageEngagement: "",
                                  isErrorSkuList: false,
                                  errorSkuList: [],
                                  iCodeError: false,
                                });
                              }
                              e.target.value.trim().length === 10 &&
                                setIsEngagementCodeChanged(true);
                            }}
                            onBlur={(e) => {
                              validateEngagementCode(e.target.value.trim());
                            }}
                            hideClearButton={true}
                            prefix={
                              <MotifIcon
                                src={IconoirCodepen}
                                className={`engagementCode-icon ${
                                  isEngagementCodeError ? "error" : ""
                                }`}
                              />
                            }
                            suffix={
                              isEngagementCodeError ? (
                                <MotifIcon
                                  src={IconoirWarningCircle}
                                  className="engagementCode-icon error"
                                />
                              ) : (
                                ""
                              )
                            }
                            error={
                              isEngagementCodeError
                                ? {
                                    isError: engagementError.isErrorEngagement,
                                    message: engagementError.messageEngagement,
                                  }
                                : undefined
                            }
                          />
                          <div
                            className={`engagement-name ${
                              engagementName !== "" && !engagementNameError
                                ? ""
                                : "hide"
                            }`}
                          >
                            {engagementNameInStore !== null
                              ? renderEngagementName(
                                  //@ts-ignore
                                  engagementNameInStore[0].engagementName,
                                )
                              : ""}
                            {engagementNameLoading && <Loader />}
                          </div>
                        </div>
                        {getEngagementError(
                          isEngagementCodeError,
                          engagementError,
                        )}
                      </div>
                    </div>
                    <div
                      className={`cost-breakdown-table engagementCode ${
                        !showEngagementException ? "hide" : ""
                      }`}
                    >
                      <div className="discription-row InputElement">
                        <label htmlFor="engagementCode">
                          Provide an E-Code for this exception (required)
                        </label>
                        <div className="engagement-grid">
                          <InputBox
                            aria-label="Engagement Code Exception"
                            name="engagementCodeException"
                            label="Engagement Code Exception"
                            placeholder="Enter a valid E-Code"
                            className="engagementCode-name-input"
                            type="text"
                            readonly={viewMode}
                            value={engagementCodeException}
                            onChange={(e) => {
                              setEngagementCodeException(e.target.value.trim());
                              e.target.value.trim().length === 10 &&
                                setIsEngagementCodeChanged(true);
                              if (engagementExceptionError.isErrorEngagement) {
                                setEngagementExceptionError({
                                  ...engagementExceptionError,
                                  isErrorEngagement: false,
                                  messageEngagement: "",
                                  isErrorSkuList: false,
                                  errorSkuList: [],
                                  iCodeError: false,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              validateEngagementCode(engagementCode.trim());
                              validateEngagementCodeException(
                                e.target.value.trim(),
                              );
                            }}
                            hideClearButton={true}
                            prefix={
                              <MotifIcon
                                src={IconoirCodepen}
                                className={`engagementCode-icon ${
                                  isEngagementCodeErrorException ? "error" : ""
                                }`}
                              />
                            }
                            suffix={
                              isEngagementCodeErrorException ? (
                                <MotifIcon
                                  src={IconoirWarningCircle}
                                  className="engagementCode-icon error"
                                />
                              ) : (
                                ""
                              )
                            }
                            error={
                              isEngagementCodeErrorException
                                ? {
                                    isError:
                                      engagementExceptionError.isErrorEngagement,
                                    message:
                                      engagementExceptionError.messageEngagement,
                                  }
                                : undefined
                            }
                          />
                          <div
                            className={`engagement-name ${
                              engagementNameException !== "" &&
                              !engagementNameExceptionError
                                ? ""
                                : "hide"
                            }`}
                          >
                            {engagementNameExceptionInStore !== null
                              ? renderEngagementName(
                                  //@ts-ignore
                                  engagementNameExceptionInStore[0]
                                    .engagementName,
                                )
                              : ""}
                            {engagementNameExceptionLoading && <Loader />}
                          </div>
                        </div>
                        {getEngagementErrorException()}
                      </div>
                    </div>
                  </div>
                  <div className="checkout-content-body-view-details-btns second">
                    <div className="checkout-view-details-btn-wrapper">
                      <Button
                        className="checkout-view-details-cancel-btn"
                        variant="secondary"
                        onClickHandler={() => {
                          setIsAddProductFlow(false);
                          handleSaveEstimate();
                        }}
                        label="Save estimate"
                        disabled={
                          !!(
                            viewMode ||
                            disableBtns ||
                            engagementNameError ||
                            engagementNameExceptionError ||
                            opportunityError ||
                            opportunityNameError ||
                            (engagementError.isErrorEngagement &&
                              !engagementError.iCodeError &&
                              engagementCode !== "") ||
                            engagementNameLoading ||
                            engagementNameExceptionLoading ||
                            engagementNameExceptionError ||
                            engagementExceptionError.isErrorEngagement
                          )
                        }
                        loading={isLoadingEstimate && !isLoadingConfirmation}
                      />
                    </div>
                    <div className="checkout-view-details-btn-wrapper">
                      <Button
                        className="checkout-view-details-save-btn"
                        variant="primary"
                        onClickHandler={handleOrderNow}
                        label="Order now"
                        //@ts-ignore
                        disabled={
                          viewMode ||
                          disableBtns ||
                          engagementNameError ||
                          engagementNameLoading ||
                          engagementNameExceptionLoading ||
                          engagementNameExceptionError ||
                          opportunityError ||
                          opportunityNameError ||
                          engagementError.isErrorEngagement ||
                          engagementExceptionError.isErrorEngagement ||
                          (showEngagementException &&
                            engagementCodeException.length === 0) ||
                          retiredSkuList.length > 0
                        }
                        loading={isLoadingOrderNow}
                        children={
                          <MotifIcon
                            iconFunction={IconoirArrowRight}
                            size="24"
                            title="Add to Order Bundle"
                          />
                        }
                      />
                    </div>
                  </div>
                  <div>{getInvaidErrorHandleSave()}</div>
                  <div className="checkout-content-body-view-details-btns">
                    <div className="checkout-view-details-btn-wrapper">
                      <Button
                        className="checkout-view-details-cancel-btn"
                        variant="secondary"
                        onClickHandler={async () => {
                          setIsLoadingAddProduct(true);
                          setIsAddProductFlow(true);

                          if (
                            checkOutListState?.OrderStatus === "order_estimate"
                          ) {
                            const result = await handleSaveEstimate(true);
                            setIsLoadingAddProduct(false);
                            if (result === false) {
                              return;
                            }
                            setIsAddProductFlow(false);
                            navigate("/marketplace");
                          } else {
                            await handleSyncCheckoutPage(true);
                            setIsLoadingAddProduct(false);
                            setIsAddProductFlow(false);
                            navigate("/marketplace");
                          }
                        }}
                        label={`${checkOutListState?.OrderStatus === "order_estimate" ? "Save and add another product" : "Add another product"}`}
                        disabled={
                          !!(
                            viewMode ||
                            disableBtns ||
                            engagementNameError ||
                            engagementNameExceptionError ||
                            opportunityError ||
                            opportunityNameError ||
                            (engagementError.isErrorEngagement &&
                              !engagementError.iCodeError &&
                              engagementCode !== "") ||
                            engagementNameLoading ||
                            engagementNameExceptionLoading ||
                            engagementNameExceptionError ||
                            engagementExceptionError.isErrorEngagement
                          )
                        }
                        loading={isLoadingAddProduct}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* {selectedTab === 1 && (
              <div className="checkout-content-body-skus">under process</div>
            )} */}
          </section>
        )}
      </div>
      <UpdateOrderWarningPopUp
        isVisible={isOrderUpdateWarning}
        name={orderName}
        popupCloseHandler={popupCloseHandler}
      />
      <EngagementConfirmationModal
        isVisible={opportunityMismatchError?.isErrorOpportunity}
        isLoading={isLoadingConfirmation}
        cancelBtnRejectHandler={() => {
          setIsAddProductFlow(false);
          resetEngagementCode({
            opportunityMismatchError,
            setEngagementCodeException,
            setEngagementCode,
            engagementCode,
            engagementCodeException,
            resetOpportunityMismatchError,
          });
        }}
        confirmBtnApproveHandler={async () => {
          setIsLoadingConfirmation(true);
          setOpportunityCodeMistachWithIcode(false);
          if (opportunityCodeMistachWithIcode) {
            const result = await handleSaveEstimate(
              isAddProductFlow,
              true,
              opportunityMismatchError?.nextOpportunity?.code,
            );
            if (isAddProductFlow && result !== false) {
              setIsAddProductFlow(false);
              setIsLoadingConfirmation(false);
              navigate("/marketplace");
              return;
            }
          }
          setIsAddProductFlow(false);
          updateOpportunityCode({
            opportunityMismatchError,
            setOpportunityCode,
            resetOpportunityMismatchError,
            resetOpportunityName,
          });
          setIsLoadingConfirmation(false);
        }}
        heading="Engagement and opportunity mismatch"
        message={
          <>
            <div>
              The engagement code{" "}
              <b>
                {opportunityMismatchError?.engagement?.code} –{" "}
                {opportunityMismatchError?.engagement?.name}
              </b>{" "}
              is currently linked to opportunity{" "}
              <b>
                {opportunityMismatchError?.nextOpportunity?.code} –{" "}
                {opportunityMismatchError?.nextOpportunity?.name}
              </b>
            </div>
            <div>
              If you continue, the order will be updated from Opportunity{" "}
              <b>
                {opportunityMismatchError?.opportunity?.code} –{" "}
                {opportunityMismatchError?.opportunity?.name}
              </b>{" "}
              to Opportunity{" "}
              <b>
                {opportunityMismatchError?.nextOpportunity?.code} –{" "}
                {opportunityMismatchError?.nextOpportunity?.name}
              </b>
              .
            </div>
            <div>
              This action will:
              <ol>
                <li>Update the Opportunity ID on this order.</li>
                <li>Delete the existing CRM order estimate.</li>
                <li>
                  Create a new CRM order estimate for the correct opportunity.
                </li>
              </ol>
            </div>
          </>
        }
        ConfirmBtnLabel={`Confirm update ${opportunityCodeMistachWithIcode || isLoadingConfirmation ? `& save` : ""}`}
      />
    </>
  );
};

export default Checkout;
